// @flow

import React from 'react';
import {Field, reduxForm} from 'redux-form';
import BasicFormInput from '../BasicFormInput/BasicFormInput';
import {addVAT, removeVAT} from '../../helpers/priceHelpers';
import DecimalFormInput from '../DecimalFormInput/DecimalFormInput';
import TextAreaFormInput from '../TextAreaFormInput/TextAreaFormInput';
import ReplacementFormInput from '../ReplacementFormInput/ReplacementFormInput';
import RelatedVariantsInput from '../RelatedVariantsInput/RelatedVariantsInput';
import './ProductVariantForm.css';

export type Props = {
  productTypes: any[],
  relatedProductType: ?{ id: number },
  related: any[],
  relatedProductSelected: Function,
  relatedVariantSelected: Function,
  relatedProductToggle: Function,
  relatedProductTypeToggle: Function,
  addRelatedProductType: Function,
  setRelatedProductType: Function,
  toggleReplacementDialog: Function,
  setActiveAdditional: Function,
  onUserChange: Function,
  activeVariant: ?any,
  relatedProductTypeSelected: Function,
  removeProductType: Function,
};

const ProductVariantForm = ({
  toggleReplacementDialog,
  setActiveAdditional,
  activeVariant,
  onUserChange,
  productTypes,
  relatedProductType,
  related,
  relatedProductSelected,
  relatedVariantSelected,
  relatedProductToggle,
  relatedProductTypeToggle,
  addRelatedProductType,
  setRelatedProductType,
  relatedProductTypeSelected,
  removeProductType,
}: Props) => (
  <div className="ProductVariantForm">
    <form>
      <div className="row">
        <div className="small-6 column">
          <Field
            name="name"
            label="Namn"
            onChange={onUserChange}
            component={BasicFormInput}
            type="text" />
          <Field
            name="itemNumber"
            label="Internt artikelnummer"
            onChange={onUserChange}
            component={BasicFormInput}
            type="text" />
          <Field
            name="externalItemNumber"
            label="Externt artikelnummer"
            onChange={onUserChange}
            component={BasicFormInput}
            type="text" />
          <Field
            name="buyingPrice"
            label="Inköpspris exklusive moms"
            onChangeTransform={addVAT}
            valueTransform={removeVAT}
            onChange={onUserChange}
            component={DecimalFormInput} />
          <Field
            name="buyingPrice"
            label="Inköpspris inklusive moms"
            onChange={onUserChange}
            component={DecimalFormInput} />
          <Field
            name="sellingPrice"
            label="Säljpris exklusive moms"
            onChangeTransform={addVAT}
            valueTransform={removeVAT}
            onChange={onUserChange}
            component={DecimalFormInput} />
          <Field
            name="sellingPrice"
            label="Säljpris inklusive moms"
            onChange={onUserChange}
            component={DecimalFormInput} />
        </div>
        <div className="small-6 column">
          <Field
            name="color"
            label="Färg"
            onChange={onUserChange}
            component={BasicFormInput}
            type="text" />
          <Field
            name="sizeWidth"
            label="Bredd (cm)"
            onChange={onUserChange}
            component={DecimalFormInput} />
          <Field
            name="sizeHeight"
            label="Höjd (cm)"
            onChange={onUserChange}
            component={DecimalFormInput} />
          <Field
            name="sizeDepth"
            label="Djup (cm)"
            onChange={onUserChange}
            component={DecimalFormInput} />
          {activeVariant &&
            <Field
              name="replacement"
              label="Ersättningsprodukt"
              toggleReplacementDialog={toggleReplacementDialog}
              onChange={onUserChange}
              component={ReplacementFormInput} />
          }
        </div>
      </div>
      <div className="row">
        <div className="small-6 column">
          <Field
            name="externalDescription"
            label="Extern beskrivning"
            onChange={onUserChange}
            component={TextAreaFormInput}
          />
        </div>
        <div className="small-6 column">
          <Field
            name="internalDescription"
            label="Intern beskrivning"
            onChange={onUserChange}
            component={TextAreaFormInput}
          />
        </div>
      </div>
      <div className="row related-row">
        <div className="small-12 column">
          <Field
            name="related"
            label="Kombinationsprodukt"
            productTypes={productTypes}
            relatedProductType={relatedProductType}
            setRelatedProductType={setRelatedProductType}
            addRelatedProductType={addRelatedProductType}
            related={related}
            productSelected={relatedProductSelected}
            variantSelected={relatedVariantSelected}
            productToggle={relatedProductToggle}
            productTypeToggle={relatedProductTypeToggle}
            productTypeSelected={relatedProductTypeSelected}
            removeProductType={removeProductType}
            component={RelatedVariantsInput} />
        </div>
      </div>
    </form>
  </div>
);

export default reduxForm({
  form: 'productVariant',
  enableReinitialize: true,
})(ProductVariantForm);



// WEBPACK FOOTER //
// ./src/components/ProductVariantForm/ProductVariantForm.js